import { axiosV2 } from "config/@axios";

export const SET_LOADING = "Bwlists::setLoading";
export const SET_ERROR_MESSAGE = "Bwlists::setErrorMessage";
export const FETCH_BWLISTS_SUCCESS = "Bwlists::setBwlistsSuccess";
export const RESET_BWLISTS = "Bwlists::resetBwlists";
export const ADD_TRUSTED_INCOMING_ADDRESS =
  "Bwlists::addTrustedIncomingAddress";
export const REMOVE_TRUSTED_INCOMING_ADDRESS =
  "Bwlists::removeTrustedIncomingAddress";

export const resetBwlists = () => {
  return {
    type: RESET_BWLISTS
  };
};

export const setLoading = payload => {
  return {
    type: SET_LOADING,
    payload
  };
};

export const setErrorMessage = payload => {
  return {
    type: SET_ERROR_MESSAGE,
    payload
  };
};

export const addTrustedIncomingAddress = address => ({
  type: ADD_TRUSTED_INCOMING_ADDRESS,
  payload: address
});

export const removeTrustedIncomingAddress = address => ({
  type: REMOVE_TRUSTED_INCOMING_ADDRESS,
  payload: address
});

export const fetchBwlists = () => dispatch => {
  dispatch(setLoading(true));
  return axiosV2
    .get("/bwlists")
    .then(response => {
      dispatch({
        type: FETCH_BWLISTS_SUCCESS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch(setErrorMessage(err.errorMessage));
    })
    .finally(() => dispatch(setLoading(false)));
};
